import React from 'react';
import SwiperImg from '@gp/components/SwiperImg';
import { Modal } from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';
import './index.scss';

const swiperParams: any = {
  showArrows: true,
  showIndicators: false,
  infiniteLoop: true,
  autoPlay: false,
  emulateTouch: true,
  showStatus: false,
};
const SwiperFullModal = (props: any) => {
  const { visible, onClose, imageList = [], activeSwiperIdxCur, headTitle = '' } = props;
  return (
    <Modal
      size={'auto'}
      visible={visible}
      className={'dbg-swiper-full-modal'}
      onClose={onClose}
      caption={
        <div className="dbg-swiper-full-modal-caption">
          {headTitle}
          <SvgIcon type="clonse" className="unloadModal-showImg-clonse" onClick={onClose} />
        </div>
      }
      disableCloseIcon={true}
    >
      <div className={'dbg-swiper-full-modal-content'}>
        <SwiperImg
          height={'100%'}
          width={'100%'}
          urlList={imageList}
          params={swiperParams}
          activeSwiperIdxCur={activeSwiperIdxCur}
          noDataTip={''}
        />
      </div>
    </Modal>
  );
};
export default SwiperFullModal;
